/* global Handlebars */

var permissionsHandlebars = require('permissions/Handlebars')

Handlebars.registerHelper('permissibleButton', permissionsHandlebars.Button)
Handlebars.registerHelper('permissibleContainer', permissionsHandlebars.Container)
Handlebars.registerHelper('permissibleInput', permissionsHandlebars.Input)
Handlebars.registerHelper('permissibleLink', permissionsHandlebars.Link)
Handlebars.registerHelper('permissibleText', permissionsHandlebars.Text)
